export function makePluginDownloadPath(pluginId) {
    return `/plugins/downloads?pluginId=${pluginId}`;
}
